import { render } from "./Marks.vue?vue&type=template&id=6938b681"
import script from "./Marks.vue?vue&type=script&lang=js"
export * from "./Marks.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3774952006/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__